import { render, staticRenderFns } from "./AbkNewNewsForm.vue?vue&type=template&id=63366fa6&scoped=true&"
import script from "./AbkNewNewsForm.vue?vue&type=script&lang=js&"
export * from "./AbkNewNewsForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewNewsForm.vue?vue&type=style&index=0&id=63366fa6&scoped=true&lang=scss&"
import style1 from "./AbkNewNewsForm.vue?vue&type=style&index=1&id=63366fa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63366fa6",
  null
  
)

export default component.exports